/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Expression } from "abreact/expression/Expression";
import * as AbHooks from "abreact/utils/AbHooks";
import { ExpressionApiServices } from "abweb/generated/abwebinternal/api/expressionservice/ExpressionApiServices";
import { useEffect, useMemo, useState } from "react";
export let ExpressionHooks;
(function (_ExpressionHooks) {
  const staticDomainCacheByApi = new Map();
  function useExpressionDefinition(expression) {
    return useMemo(() => {
      return typeof expression === "string" ? Expression.Definition.parse(expression) : expression;
    }, [expression]);
  }
  _ExpressionHooks.useExpressionDefinition = useExpressionDefinition;
  function useExpressionDomain(domainID, expressionAPI) {
    const [storedDomain, setStoredDomain] = useState();
    const mounted = AbHooks.useIsMounted();
    useEffect(() => {
      if (domainID) {
        const api = expressionAPI ?? ExpressionApiServices.getExpressionApi();
        let cacheForApi = staticDomainCacheByApi.get(api);
        if (!cacheForApi) {
          cacheForApi = new Map();
          staticDomainCacheByApi.set(api, cacheForApi);
        }
        let promiseForDomain = cacheForApi.get(domainID);
        if (!promiseForDomain) {
          promiseForDomain = api.getExpressionDomain(domainID);
          cacheForApi.set(domainID, promiseForDomain);
        }
        promiseForDomain.then(newDomain => {
          mounted.current && setStoredDomain(newDomain);
        });
      }
    }, [domainID, expressionAPI]);
    return storedDomain;
  }
  _ExpressionHooks.useExpressionDomain = useExpressionDomain;
})(ExpressionHooks || (ExpressionHooks = {}));
//# sourceMappingURL=ExpressionHooks.js.map
